<!-- ads-images -->

<template>
  <van-swipe :autoplay="3000" :show-indicators="false" class="my-swipe" :style="'border-radius:' + imageRadius + 'px;'">
    <van-swipe-item v-for="(img, index) in adImageList" :key="index">
      <van-image :radius="imageRadius" :src="img" fit="cover"></van-image>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { mall_Goods_get_Ads_Images } from "@/api/goods-api";

import request from "@/util/axios";

export default {
  name: "ads-images",

  data() {
    return {
      adImageList: [],
    };
  },

  props: {
    imageRadius: { type: Number, default: 8 },
    adId: { type: Number, default: 36 }, // 生产环境首页轮播图
    code: { type: String }, //
  },

  created() {
    if (this.code) {
      // 新的 根据 code 查询
      var formData = new FormData();
      formData.append("code", this.code);

      request.post("/mall/wx/Goods/get-ad-images-by-code", formData).then((res) => {
        if (!res || !res.data) {
          budo_log.info("#35 created get-ad-images-by-code");
          return;
        }

        this.adImageList = res.data.map((item) => item.imageUrl);
      });
      return;
    }

    // 老的 根据ID查询
    mall_Goods_get_Ads_Images(this.adId).then((res) => {
      budo_log.debug("#46 mall_Goods_get_Ads_Images", res);
      var data = res.data || [];

      this.adImageList = data.map((item) => item.imageUrl);
    });
  },
};
</script>

<style lang="scss" scoped>
.my-swipe {
  .van-swipe-item {
    font-size: 20px;
    line-height: 150px;
    height: 150px;
    text-align: center;
  }
}
</style>
